module.exports = __webpack_public_path__ + "static/header_contact_tbh-43c064ccce5324d6da4857e4a77548d5.jpg";